module.exports = __webpack_public_path__ + "static/assets/9c5c07350a2064946aa389ffb31dc9f2.svg";